import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { CreateChainAgencyLegalDataParams } from '../../agency/create-chain-agency-legal-data'

interface CreateChainAgencyLegalDataPayload {
  legalData: CreateChainAgencyLegalDataParams
}

export const mockCreateChainAgencyLegalData = http.post<
  never,
  CreateChainAgencyLegalDataPayload
>(
  '/my-business/api/agency/v1/agency-chains/legal-data',
  async ({ request }) => {
    const { legalData } = await request.json()

    if (legalData.taxpayerId === '00000000000000') {
      const error = {
        message: 'E001',
        detail: 'CNPJ Inválido',
      }

      return HttpResponse.json({ error }, { status: 400 })
    }

    return HttpResponse.json({ alphaId: faker.string.uuid() }, { status: 201 })
  },
)
